import { ColorEnum } from '@/constants/color'
import Notification from '@/features/notifications/components/Notification'
import ListItem from '@/features/notifications/components/NotificationCenter/parts/ListItem/Component'
import TitleAndBadge from '@/features/notifications/components/NotificationCenter/parts/ListItem/parts/TitleAndBadge'
import PotIcon from '@/features/notifications/components/icons/PotIcon'
import { FC } from 'react'

interface NewOrderProps {
    heading: string
    createdAt: number
    title: string
    orderShortCode: string
    orderCustomerName?: string
    read: boolean
    onPress: () => void
}

const NewOrder: FC<NewOrderProps> = ({
    heading,
    createdAt,
    title,
    orderShortCode,
    orderCustomerName,
    read,
    onPress,
}) => {
    return (
        <ListItem
            Icon={PotIcon}
            iconContainerColor={ColorEnum.EMERALD_200}
            heading={heading}
            createdAt={createdAt}
            Title={<TitleAndBadge title={title} badge={orderShortCode} />}
            Description={
                orderCustomerName && (
                    <Notification.Description>{orderCustomerName}</Notification.Description>
                )
            }
            read={read}
            onPress={onPress}
        />
    )
}

export default NewOrder
